import React from 'react';

import WhatsChangedOcfView from './WhatsChangedOcfView';

const WhatsChangedOcfModuleController = props => {
  const defaultTestId = `whatsChanged`;

  return <WhatsChangedOcfView {...props} defaultTestId={defaultTestId} />;
};

export default WhatsChangedOcfModuleController;
